/**
 * In-app feedback client. Messages POST to the leaderboard API's /feedback
 * route and land in the shared DynamoDB table under the 'feedback' partition
 * (see packages/infra/lambda/leaderboard.ts).
 */
import { API_ENDPOINT, getPlayerName } from './leaderboard';

export const MAX_FEEDBACK_LEN = 2000;

/** 'ios' | 'android' | 'web' — via the Capacitor global so web builds need no import. */
function platform(): string {
  try {
    const cap = (window as unknown as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
    return cap?.getPlatform?.() ?? 'web';
  } catch {
    return 'web';
  }
}

/** Sends one feedback message; throws on a non-OK response so the form can show a retry state. */
export async function submitFeedback(message: string): Promise<void> {
  const trimmed = message.trim().slice(0, MAX_FEEDBACK_LEN);
  if (!trimmed) return;
  const res = await fetch(`${API_ENDPOINT}/feedback`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      message: trimmed,
      playerName: getPlayerName() || 'anon',
      platform: platform(),
      appVersion: __APP_VERSION__,
    }),
  });
  if (!res.ok) throw new Error(`feedback submit failed (${res.status})`);
}
